import { TipTapBaseNode } from '../../../components/Viewer/renderer';
import { cleanLinkSrc } from '../../../components/Viewer/useHandlers';
import { EXTENSION_TYPE_NAME } from '../constants';
import { DaGifAttrs, DaGifOptions } from '../gif';
import { useWidth } from '../hooks/useWidth';
import cn from 'classnames';

import s from './Viewer.scss';

interface Props {
  node: TipTapBaseNode;
}

const Viewer = ({ node }: Props) => {
  const attrs: DaGifAttrs = node.attrs as DaGifAttrs;
  const { alignment } = attrs;
  const config = node.extensionConfig?.gif as DaGifOptions;
  const align = alignment === 'left' ? s['left'] : alignment === 'right' ? s['right'] : s['center'];

  const { width, maxWidth } = useWidth(
    attrs.width ?? 780,
    config.defaultWidth,
    config.smallMedia ?? false,
    attrs.alignment ?? config.defaultAlignment,
    node.containerWidth
  );
  const newWidth = Math.min(maxWidth, width ?? config.defaultWidth);
  const height = (newWidth / (attrs.width ?? 0)) * (attrs.height ?? 0);

  const url = cleanLinkSrc(attrs?.url || '', ['giphy.com']);

  return (
    <div
      data-da-type="da-gif"
      data-width={attrs.width}
      data-height={attrs.height}
      data-alignment={attrs.alignment}
      data-url={attrs.url}
      className={cn(
        s['gif-container'],
        align,
        config?.smallMedia && s['small-media'],
        s[`preset-${node.presetId}`]
      )}
    >
      {attrs && url && (
        <video
          role="img"
          autoPlay
          muted
          loop
          style={{
            pointerEvents: 'none',
          }}
          controlsList="nofullscreen"
          playsInline // required to disable fullscreen iOS
          aria-label="gif"
          data-da-type={EXTENSION_TYPE_NAME}
          width={newWidth}
          height={height}
          src={url}
          className={s['gif-video']}
        ></video>
      )}
    </div>
  );
};

export default Viewer;
